import { Machine, assign } from "xstate";

const loginMachine = Machine({
  id: "login",
  initial: "idle",
  context: {
    mfaEnabled: false,
  },
  states: {
    idle: {
      on: {
        LOGIN: "loading",
      },
    },
    loading: {
      on: {
        RESOLVE: "success",
        MFA: {
          target: "idle",
          actions: assign({
            mfaEnabled: true,
          }),
        },
        MFA_SETUP: {
          target: "setupMfa",
        },
        REJECT: "failure",
        REJECTMFA: "failureMfa",
      },
    },
    success: {
      type: "final",
    },
    failure: {
      on: {
        LOGIN: "loading",
      },
    },
    failureMfa: {
      on: {
        LOGIN: "loading",
      },
    },
    setupMfa: {
      on: {
        LOGIN: {
          target: "idle",
        },
      },
    },
  },
});

export default loginMachine;
